/**
 * Desktop mega menu: open on hover (OUR STORE etc.)
 */
(function () {
  const DESKTOP = '(min-width: 990px)';

  function bindHoverMenus() {
    if (!window.matchMedia(DESKTOP).matches) return;

    document.querySelectorAll('header-menu').forEach((wrapper) => {
      const details = wrapper.querySelector('details.mega-menu');
      if (!details || wrapper.dataset.mieHoverBound === 'true') return;

      wrapper.dataset.mieHoverBound = 'true';
      let closeTimer;

      const openMenu = () => {
        clearTimeout(closeTimer);
        details.setAttribute('open', '');
      };

      const closeMenu = () => {
        closeTimer = window.setTimeout(() => {
          details.removeAttribute('open');
        }, 150);
      };

      wrapper.addEventListener('mouseenter', openMenu);
      wrapper.addEventListener('mouseleave', closeMenu);

      const summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (event) => {
          if (window.matchMedia(DESKTOP).matches) {
            event.preventDefault();
            openMenu();
          }
        });
      }
    });
  }

  function resetMobileMenus() {
    if (window.matchMedia(DESKTOP).matches) return;
    document.querySelectorAll('header-menu details.mega-menu[open]').forEach((details) => {
      details.removeAttribute('open');
    });
  }

  function init() {
    resetMobileMenus();
    bindHoverMenus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', init);
})();
